import React from 'react';
import PortfolioComp from 'shared/components/portfolio/PortfolioComp';
import ServiceDetailPage from '../ServiceDetailPage';

const portfolioConfig = {
  pageClass: 'portfolio-detail-page',
  eyebrow: 'Portfolio access',
  title: 'Protected market watchlist.',
  copy: 'A password-gated portfolio resource for users who complete the BingX partner route and send proof for manual access review.',
  actions: [
    { label: 'Open BingX', href: 'https://bingx.com/en/partner/Cryptoxnft/' },
    { label: 'Send Proof', href: 'https://t.me/cryptoxnftsignals', variant: 'secondary' },
  ],
  metrics: [
    { value: '500 USD', label: 'Deposit path', note: 'Current requirement' },
    { value: 'BingX', label: 'Partner route', note: 'Use CRYPTOXNFT' },
    { value: 'Locked', label: 'Watchlist', note: 'Password gated' },
  ],
  visual: {
    kicker: 'WATCHLIST DESK',
    badge: 'PORTFOLIO',
    label: 'Portfolio access preview',
    rows: [
      { label: 'Route', title: 'BingX partner', meta: 'Step 1' },
      { label: 'Proof', title: 'Deposit check', meta: '$500' },
      { label: 'Access', title: 'Watchlist unlock', meta: 'Manual' },
    ],
    chips: ['Partner route', 'Deposit proof', 'Protected table', 'Admin review'],
    media: {
      src: '/assets/images/services/tradingData.jpg',
      alt: 'Trading data portfolio preview',
      label: 'Protected resource preview',
    },
  },
  featuresIntro: {
    eyebrow: 'What users get',
    title: 'Market context that stays gated until access is approved.',
    copy: 'The page should explain the requirement, show the protected resource, and keep the next action obvious.',
  },
  features: [
    {
      label: 'Watchlist',
      title: 'Portfolio table',
      copy: 'Coin entries and targets stay protected until the user is verified.',
    },
    {
      label: 'Partner',
      title: 'BingX path',
      copy: 'The access flow depends on the preserved BingX destination or CRYPTOXNFT code.',
    },
    {
      label: 'Review',
      title: 'Manual proof',
      copy: 'Users send proof to admin, then receive the password after approval.',
    },
  ],
  flowIntro: {
    eyebrow: 'Access flow',
    title: 'Use the exact route before requesting access.',
    copy: 'The requirement is intentionally clear so users know what admin will need to verify.',
  },
  steps: [
    {
      title: 'Create BingX account',
      copy: 'Use the official partner link or CRYPTOXNFT code before depositing.',
    },
    {
      title: 'Deposit 500 USD',
      copy: 'Keep proof connected to the account that used the partner route.',
    },
    {
      title: 'Send proof to admin',
      copy: 'Message Telegram admin for manual review and password access.',
    },
  ],
  proofIntro: {
    eyebrow: 'Resource preview',
    title: 'Show the value without exposing the full table.',
    copy: 'The preview keeps the page useful even before password verification.',
  },
  proofItems: [
    {
      src: '/assets/images/services/tradingData.jpg',
      alt: 'Trading data preview',
      label: 'Market data preview',
    },
    {
      src: '/assets/images/services/indicator.png',
      alt: 'Indicator preview image',
      label: 'Analysis context',
    },
    {
      src: '/assets/images/services/copy/tradingData.png',
      alt: 'Trading data screenshot',
      label: 'Watchlist style',
    },
  ],
  notice: 'Portfolio entries and targets are educational watchlist material. They are not financial advice and do not remove market risk.',
  resource: {
    intro: {
      eyebrow: 'Protected table',
      title: 'Enter the access password after approval.',
      copy: 'The existing password-gated portfolio component stays intact, but now sits inside the same premium service layout.',
    },
    content: <PortfolioComp />,
  },
  finalCta: {
    eyebrow: 'Next step',
    title: 'Complete the BingX proof route.',
    copy: 'Open the partner destination, send proof after the required deposit, and wait for manual approval.',
    actions: [
      { label: 'Open BingX', href: 'https://bingx.com/en/partner/Cryptoxnft/' },
      { label: 'Send Proof', href: 'https://t.me/cryptoxnftsignals', variant: 'secondary' },
    ],
  },
};

function Portfolio() {
  return <ServiceDetailPage {...portfolioConfig} />;
}

export default Portfolio;
